export default __webpack_public_path__ + "static/media/IconInstagram.93628508.svg";